import * as React from 'react';

import CoursesV1 from 'bundles/naptimejs/resources/courses.v1';
import ConsumerEnrollButtonNotConfigurable from 'bundles/unified-description-page-common/components/enroll/consumer/ConsumerEnrollButtonNotConfigurable';
import type { ConsumerCoursePageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/ConsumerCoursePageQuery';

const ConsumerCourseEnrollButtonNotConfigurable = ({
  pageData,
  size,
  onlyShowButton,
  hideFinaidLink,
}: {
  pageData?: ConsumerCoursePageFieldsFragment;
  size?: 'small' | 'large';
  // WARNING: This will hide dynamic critical links/messages next to the enroll button (like finaid link).
  // Only add this prop if the button is being used as the non-primary CTA (like in page nav).
  onlyShowButton?: boolean;
  hideFinaidLink?: boolean;
}) => {
  if (!pageData) {
    return null;
  }

  return (
    <ConsumerEnrollButtonNotConfigurable
      s12nId={pageData.activeSpecialization ? pageData.activeSpecialization.id : pageData.primarySpecialization?.id}
      partnerIds={pageData?.partners?.map(({ id }) => id)}
      courseCount={
        pageData.activeSpecialization
          ? pageData.activeSpecialization.courseCount
          : pageData.primarySpecialization?.courseCount
      }
      onStickyHeader={size === 'small'}
      onlyShowButton={onlyShowButton}
      isSpecialization={false}
      name={pageData.name}
      slug={pageData.slug}
      courseId={pageData.id}
      hideFinaidLink={hideFinaidLink}
      course={
        new CoursesV1({
          slug: pageData.slug,
          id: pageData.id,
          name: pageData.name,
          courseType: pageData.courseType,
          courseStatus: pageData.courseStatus,
          certificates: pageData.certificates,
          premiumExperienceVariant: pageData.premiumExperienceVariant,
        })
      }
    />
  );
};

export default ConsumerCourseEnrollButtonNotConfigurable;
